import React from "react";
import { SESSION_STATUS } from "./attendanceFormat";

/** VALID / APPROVED green · FOR_REVIEW amber · REJECTED red (struck through: not counted). */
const SessionStatusBadge = ({ status, reason }) => {
  const meta = SESSION_STATUS[status] || { label: status || "—", tone: "gray" };
  return (
    <span
      className={`status-pill status-pill--${meta.tone} ${status === "REJECTED" ? "session-rejected" : ""}`}
      title={
        reason ||
        (status === "REJECTED"
          ? "Rejected time isn't counted in hours"
          : undefined)
      }
    >
      {meta.label}
    </span>
  );
};

export default SessionStatusBadge;
